import type { Client } from '@openphone/internal-api-client'
import { commitLocalUpdate, Environment, RecordSource } from 'relay-runtime'

import { createNetworkWithPerformanceTracking } from '@src/graphql/createNetworkWithPerformanceTracking'
import createRelayPerformanceLogFunction from '@src/graphql/createRelayPerformanceLogFunction'

import { RetainTrackingStore } from './RetainTrackingStore'
import { getDataID } from './getDataID'
import relayFieldLogger from './relayFieldLogger'
import type { RelayResolverContext } from './resolverContext'

interface CreateRelayEnvironmentParams {
  httpClient: Client
  getViewerId: RelayResolverContext['getViewerId']
}

export function createRelayEnvironment({
  httpClient,
  getViewerId,
}: CreateRelayEnvironmentParams) {
  // Subscriptions do not replay events missed while disconnected.
  const network = createNetworkWithPerformanceTracking({
    httpClient,
    onReconnect: () => {
      commitLocalUpdate(environment, (store) => store.invalidateStore())
    },
  })

  const environment = new Environment({
    network,
    store: new RetainTrackingStore(new RecordSource(), {
      queryCacheExpirationTime: 5 * 60 * 1000, // 5 minutes
      resolverContext: { getViewerId },
    }),
    getDataID,
    relayFieldLogger,
    log: createRelayPerformanceLogFunction(),
  })

  return environment
}
